angular.module('signalflow-mocks', []);
